import { paginationSize } from "../../../constants/constants";
import {ADD_UPDATE_EXAMCODE_SUCCESS, FETCH_ALL_EXAMCODES_ERROR, FETCH_ALL_EXAMCODES_START, FETCH_ALL_EXAMCODES_SUCCESS, RESET_EXAMCODES, SET_ALL_EXAMCODES_PAGINATION} from "../../actions/admin/examCodesActions";
import _ from 'lodash';

const INIT_STATE = {
    error: '',
    loading: false,
    message: '',
    examCodes: [],
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
    sortConditions: [{ sortBy: "code", dataType: "Long", sortType: "desc" }]
}

const examCodesReducer = (state = INIT_STATE, action) => {
    let newState;
    switch (action.type) {
        case FETCH_ALL_EXAMCODES_START: {
            return { ...state, loading: true };
        }
        case FETCH_ALL_EXAMCODES_SUCCESS: {
            const examCodes = action.data.examCodes.length > 0 ? [...action.data.examCodes] : [];
            return { ...state, loading: false, examCodes };
        }
        case FETCH_ALL_EXAMCODES_ERROR: {
            return { ...state, loading: false };
        }
        case RESET_EXAMCODES: {
            return { ...INIT_STATE }
        }

        case ADD_UPDATE_EXAMCODE_SUCCESS: {
            newState = _.cloneDeep(state);
            let index = state.examCodes.findIndex(examCode => examCode.id === action.examCode.id);
            if (index > -1) {
                let newExamCode ={
                    ...action.examCode,
                    rate: action.examCode.eightyFivePct
                }
                newState.examCodes[index] = { ...newExamCode }
            } else {
                let newExamCode ={
                    ...action.examCode,
                    rate: action.examCode.eightyFivePct
                }
                newState.examCodes.push(newExamCode)
            }
            return { ...newState, loading: false };
        }
        case SET_ALL_EXAMCODES_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        default:
            return state;
    }
}

export default examCodesReducer;
